/* eslint-disable no-nested-ternary */
import React, { createContext, useReducer } from 'react';


export const CartContext = createContext();

const { Provider } = CartContext;

const initialState = {
  cartData: [],
  message: '',
  totalPrice: 0,
  orderItem: [],
  loaded: false,
  stock: [],
  itemCount: 0,
  outOfStockError: 'Out of stock',
};

const cartReducer = (state, action) => {
  switch (action.type) {
    case 'cartData': {
      const res = action.data;
      const cartDataArr = [];
      let mssg = '';
      if (res.length > 0) {
        res.map((data) => {
          if (data.order_items.length > 0 && data?.order_items[0]?.purchased_entity?.type !== "customer_membership") {
            cartDataArr.push(data);
          } else {
            mssg = 'Your cart is currently empty!';
          }
        });
      } else {
        mssg = 'Your cart is currently empty!';
      }
      return {
        ...state,
        loaded: true,
        cartData: cartDataArr,
        message: mssg,
      };
    }
    case 'orderItem': {
      const totalItems = action.data.length;
      return {
        ...state,
        orderItem: action.data,
        itemCount: totalItems,
      };
    }
    case 'totalPrice': {
      return {
        ...state,
        totalPrice: action.data,
      };
    }
    case 'stockValue': {
      return {
        ...state,
        stock: action.stock,
      };
    }
    default:
      return state;
  }
};

const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cartReducer, initialState);

  return (
    <Provider value={{
      state, dispatch,
    }}
    >
      {children}
    </Provider>
  );
};
export default CartProvider;
